<template>
    <div ref="widget">
        <slot></slot>
    </div>
</template>

<script type="text/babel">
export default {
    name: 'kendo-window',

    props: {
        width: {
            type: Number,
            default: 540
        },
        visible: {
            type: Boolean,
            default: false
        }
    },

    data () {
        const config = {
            width: this.width,
            resizable: false,
            draggable: true,
            visible: false,
            title: '',
            appendTo: 'body',
            close: this.onClose
        };

        return {
            config,
            widget: Object
        };
    },

    methods: {
        onClose () {
            this.$emit('close');
        },

        open () {
            this.widget.center().open();
        },

        close () {
            this.widget.close();
        }
    },

    mounted () {
        this.widget = new kendo.ui.Window(this.$refs.widget, this.config);

        if (this.visible) {
            this.open();
        }
    },

    destroyed () {
        this.widget.destroy();
    },

    watch: {
        visible (visible) {
            return visible ? this.open() : this.close();
        }
    }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/kendo-window/kendo-window.component.vue